var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.privateequity) ? _c('div', {
    class: {
      'active': _vm.isActive()
    },
    attrs: {
      "id": _vm.page.privateequity.$path
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky",
      value: ({
        zIndex: 1,
        stickyTop: 0
      }),
      expression: "{ zIndex: 1, stickyTop: 0 }"
    }],
    staticClass: "section__top"
  }, [_c('div', [_c('div', {
    staticClass: "section__text reduced-width"
  }, [_c('PageTitle', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "isActive": _vm.isActive(),
      "isAnimated": _vm.isAnimated,
      "titleValue": _vm.page.privateequity.title
    }
  }), _vm._v(" "), _c('Description', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "descrValue": _vm.page.privateequity.text_description,
      "isActive": _vm.isActive()
    }
  })], 1)])])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50569d8b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PrivateEquity.vue
// module id = 192
// module chunks = 0